import {
  PriceSlider,
  WeightSlider,
  SizeSlider,
  DepthPercentageSlider,
  TablePercentageSlider,
  LWRatioSlider
} from '../../utils/slider-configs'

export const initialFilterState = {
  shapes: [], // All
  weight: [WeightSlider.min, WeightSlider.max], // All
  size: [SizeSlider.min, SizeSlider.max], // All
  cut: [0, 3], // Ideal to Very Good
  colour: [0, 6], // D - I
  colourFancy: [], // All
  fancyIntensity: [0, 9], // Faint - Fancy Deep
  clarity: [0, 7], // FL - SI1
  polish: [0, 3], // Ideal - Very Good
  price: [PriceSlider.min, PriceSlider.max], // All
  fluorescence: [0, 5], // None - Medium
  symmetry: [0, 3], // Ideal - Very Good
  gradingreports: ['GIA', 'AGS'],
  labreports: '',
  matchedsets: false,
  serialnumbers: '',
  canadaorigin: false,
  sizeUnit: 'carat',
  priceUnit: 'each',
  colourType: 'regular',
  depth: [DepthPercentageSlider.min, DepthPercentageSlider.max], // All
  table: [TablePercentageSlider.min, TablePercentageSlider.max], // All
  ratio: [LWRatioSlider.min, LWRatioSlider.max], // All
  withImage: true,
  orderBy: 'asc',
  sortByField: 'Sale Price CAD',
  locations: [],
  supplierTypes: ['primary'],
  suppliers: [],
  diamondType: 'natural'
}

export const initialState = {
  filters: initialFilterState,
  allSuppliers: {
    data: [],
    fetchedAt: null
  },
  results: [],
  modalRow: null,
  modalRowIndex: null,
  detailsModalOpen: false,
  compareModalOpen: false,
  advancedShown: false,
  selectedItems: [],
  highlightedRows: [],
  resultsTrueTotal: 0,
  pagination: {
    total_hits: 0,
    hits_per_page: 25,
    total_pages: 0,
    current_page: 0
  }
}



// WEBPACK FOOTER //
// ./src/reducers/diamond-search/initial-state.js